import React, { useCallback, useState } from 'react';
import { PhotoGallery } from '../components/PhotoGallery';
import { FaceBrowser } from '../components/FaceBrowser';

type PhotoItem = { id: string; url: string; originalName?: string };

const GalleryPage: React.FC = () => {
  const [photos, setPhotos] = useState<PhotoItem[]>([]);
  const [filterIds, setFilterIds] = useState<Set<string> | undefined>();

  const handlePhotosLoaded = useCallback((list: PhotoItem[]) => setPhotos(list), []);
  const handleFilter = useCallback((ids: Set<string>) => setFilterIds(new Set(ids)), []);
  const handleClear = useCallback(() => setFilterIds(undefined), []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-sage-50 via-cream-50 to-dusty-rose-50">
      <div className="container mx-auto px-4 py-6 sm:py-8">
        <div className="max-w-6xl mx-auto">
          <FaceBrowser
            photos={photos}
            onFilter={handleFilter}
            onClear={handleClear}
            autoScanIntervalMs={900_000}
            autoDeepScan={true}
          />
          <PhotoGallery
            isAdmin={false}
            hideHeader={true}
            showHoverIcon={false}
            filterPhotoIds={filterIds}
            onPhotosLoaded={handlePhotosLoaded}
            autoRefreshMs={60_000}
          />
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;
